import RadioWithLabel from "@/components/customViews/RadioGroup";
import { Label } from "@/components/ui/label";
import { RadioGroup } from "@/components/ui/radio-group";
import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import useSetDisplayModeSetting from "@/hooks/settings/useSetDisplayModeSetting";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";

const DisplayModeSelector = () => {
    const { t } = useTranslation();
    const { data: userProfile, isLoading: isLoadingUserProfile } =
        useGetUserProfile();
    const { setDisplayMode } = useSetDisplayModeSetting();

    if (isLoadingUserProfile) {
        return null;
    }

    return (
        <div className="flex w-full flex-col gap-2 py-2">
            <Label>{t("settings.homepage.displayMode.title")}</Label>
            <div className="flex items-center space-x-2">
                <div className="flex w-full items-center space-x-2 bg-surface-primary p-4">
                    <div>
                        <RadioGroup
                            className="flex gap-2"
                            onValueChange={(value) =>
                                setDisplayMode(value as EmailDisplayMode)
                            }
                            value={
                                userProfile?.settings.displayPreferences
                                    .emailDisplayMode
                            }
                        >
                            <RadioWithLabel
                                label={t(
                                    "settings.homepage.displayMode.options.list",
                                )}
                                value={EmailDisplayMode.TABLE}
                            />
                            <RadioWithLabel
                                label={t(
                                    "settings.homepage.displayMode.options.grid",
                                )}
                                value={EmailDisplayMode.MOSAIC}
                            />
                        </RadioGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisplayModeSelector;
